import React from 'react';
import { useConnect } from '@lore/query-connect';
import { PayloadStates } from '@lore/utils';
import Loader from '../../components/Loader';
import useDialogConfig from '../_hooks/useDialogConfig';
import TagNodeUpdateDialog from '../../dialogs/tagNode.update';
import { useQueryClient } from '@tanstack/react-query';

export default function Launcher(props) {
  const config = useDialogConfig();
  const queryClient = useQueryClient();

  const tagNode = useConnect('tagNode.byId', {
    id: config.params.tagNodeId
  });

  const tag = useConnect('tag.byId', {
    id: tagNode.data.tagId
  }, {
    enabled: !!tagNode.data.tagId
  });

  if (
    tagNode.state === PayloadStates.FETCHING ||
    tag.state === PayloadStates.FETCHING
  ) {
    return (
      <Loader />
    );
  }

  return (
    <TagNodeUpdateDialog
      tag={tag}
      tagNode={tagNode}
      onCancel={props.onClose}
      onSubmit={function(request) {
        queryClient.invalidateQueries({ queryKey: ['tagNode'] });
      }}
    />
  );
};
